import { useMemo } from 'react';

export const useEmbedExternalLinkProps = (isEmbed: boolean) => {
    return useMemo(() => {
        const target = isEmbed ? '_blank' : '_self';
        const rel = isEmbed ? 'noopener noreferrer' : 'nofollow';
        return { target, rel };
    }, [isEmbed]);
};

export default useEmbedExternalLinkProps;
